import api from "api/api";

export const getPersonEvaluationsQuery = async ({ id }) =>
  await api.get(`/balancesheet/person/${id}`);
